import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=1820ef52&scoped=true&"
import script from "./Login.vue?vue&type=script&scoped=true&lang=js&"
export * from "./Login.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./Login.vue?vue&type=style&index=0&id=1820ef52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1820ef52",
  null
  
)

export default component.exports